<template>
  <div class="no-data flex flex-center flex-column">
    <div class="nopage-img">
      <img src="../assets/images/norecord.png" alt="">
    </div>
    <p class="nopage-txt">{{title}}</p>
  </div>
</template>

<script>
  export default {
    name: 'no-data',
    props: {
      title: {
        type: String,
        default: '暂无数据'
      }
    }
  }
</script>

<style lang="less" scoped>
  .no-data {
    padding: 50px 0;
  }
</style>



// WEBPACK FOOTER //
// NoData.vue?705bd025